var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-div-content",style:({
    'height': _vm.emptyHeight
  })},[_c('img',{staticClass:"empty-img",attrs:{"src":"https://alphalawyer.cn/tool/images/charts-empty-data.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }